import { Warning } from "@phosphor-icons/react"
import { Divider, Modal, Note, Toast } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"

export const CloseAdvanceRequest = ({
  isOpen = false,
  onClose,
  amount,
  tradeId,
  releasedAmount = 0,
  isTrade = true,
  onSubmit,
  onCancel,
}: {
  isOpen: boolean
  onClose?: any
  amount?: any
  tradeId?: any
  releasedAmount?: any
  isTrade?: boolean
  onSubmit?: any
  onCancel?: any
}) => {
  const closeAmount = Number(amount || 0) - Number(releasedAmount || 0)
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        contentClassName=" py-5"
        headerClassName="hidden"
        bodyClassName="max-w-xl"
        primaryActionButtonProps={{
          text: "Yes, Close Advance",
          onClick: onSubmit,
        }}
        secondaryActionButtonProps={{ text: "Cancel", onClick: onCancel }}
      >
        <div className="p-5 bg-yellow-100 !rounded-full !w-fit justify-self-center">
          <Warning
            weight="fill"
            className="text-yellow-600 inline "
            size={30}
          />
        </div>
        <h1 className="text-xl font-600 mt-5 text-center">
          Are you sure you want to close this advance amount?
        </h1>
        <p className="text-[14px] font-400 text-gray-700 mt-3 text-center px-3">
          You are about to manually close an advance amount of
          <span className="font-700"> {inr(closeAmount)} </span> for this{" "}
          <span className="font-700">
            {isTrade ? "Trade" : "Receipt"} Id #{tradeId}{" "}
          </span>
        </p>
        <Toast
          className="!min-w-full text-xs mt-5 !text-[#78350F] !shadow-none border-1 border-[#FFFBEB]"
          intent="warning"
          variant="minimal"
          title={`Once closed, this ${inr(
            closeAmount
          )} cannot be used for future invoice
          adjustments. Historical adjusted amounts remain intact.`}
        ></Toast>
        <div className="bg-gray-200 border-1 border-gray-300 mt-5 p-5 rounded-lg text-gray-700 text-sm flex gap-2 flex-col">
          <div className="flex justify-between">
            <span className="font-500">Advance Requested Amount:</span>
            <span className="text-gray-800 font-700">{inr(amount || 0)}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-500">Release Amount:</span>
            <span className="text-gray-700 font-700">
              {inr(releasedAmount || 0)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-500">Amount to Close:</span>
            <span className="text-brown-400 font-700">{inr(closeAmount)}</span>
          </div>
          <Divider className="border-gray-300 border-t-1" />
          <div className="flex justify-between">
            <span className="font-500 text-gray-800">
              New Remaining Advance Balance:
            </span>
            <span className="text-green-300 font-700">{inr(0)}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
